import React from "react";

function VerticalLine() {
  return <div className="vertical-line" />;
}

export default VerticalLine;
